import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/compare-the-knot-alternative";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/compare/the-knot-alternative")({
  head: SEO["/compare/the-knot-alternative"],
  component: () => <ContentPage path="/compare/the-knot-alternative" body={body} />,
});
